import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import uz from "./locales/uz";
import uz_cyrl from "./locales/uz_cyrl";
import ru from "./locales/ru";
import es from "./locales/es";
import fr from "./locales/fr";
import pt from "./locales/pt";


const resources = {
  en,
  uz,
  uz_cyrl,
  ru,
  es,
  fr,
  pt,
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("webint_lang"), //TODO: should be result of user's choice
  fallbackLng: "en",
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
}, () => console.log(" i18n init done"));

export default i18n;